import { Routes, RouteType } from '../../common/components/utils/Routes';
import { RequireAuth } from '../RequireAuth';
import NotFoundPage from '../notFound/NotFoundPage';
import VacationAppPage from './index/VacationAppPage';

const routes: RouteType[] = [
  {
    path: '/',
    exact: true,
    component: RequireAuth(VacationAppPage)
  },
  {
    component: NotFoundPage
  }
];

const VacationsRoutes = Routes(routes);

export default VacationsRoutes;
